<template lang="pug">
.report-root
    general-title(
        title="热力图",
        description="热力图通过颜色区分为您展示您网站页面的点击情况，帮助对用户点击行为分析，优化页面设计。",
        pos="right"
    )
        .btn.btn-primary.btn-big.pull-right.add-site(@click="addNewURL")
            | 添加新热力图
    .zone
        TableTitle(icon="fa fa-signal", title="热力图列表")
        table.data-table(style="table-layout: fixed")
            thead
                tr
                    th(width="40")
                    th.ta-l(width="50%") 页面名称
                    th.ta-l(width="100%") 页面URL
                    th(width="50%") 创建时间
                    th(width="100") 统计状态
                    th(width="100") 查看热力图
                    th(width="100") 操作
            tbody
                tr(
                    v-show="!isListLoading && tableList.length",
                    v-for="(item, index) in tableList", :key="item.id"
                )
                    td(width="40")
                    td.ta-l {{item.pagename}}
                    td.ta-l
                        cite(:title="item.url | httpUrl") {{item.url | httpUrl}}
                    td {{item.createtime}}
                    td
                        VueSwitch(
                            v-model="item.bstatus",
                            :bind="false",
                            @change="changeItemBstate(item, $event)"
                            open-name="开启",
                            open-value="1",
                            close-name="暂停",
                            close-value="0",
                            color="green",
                            size="lg",
                            style="display: inline-block; vertical-align: middle;"
                        )
                    td
                        i.fa.fa-eye.fa-lg(title="查看", @click="openHeatmap(item)")
                    td.operate-cell
                        i.fa.fa-edit.fa-lg(title="修改", @click="openEdit(item)")
                        i.fa.fa-trash-o.fa-lg(title="删除", @click="deleteItem(item)")
                tr(v-show="!isListLoading && tableList.length === 0")
                    td(colspan="6", style="text-align: center;") 暂无数据
                tr(v-show="isListLoading")
                    td(colspan="6", style="text-align: center;")
                        img(src="//p.ssl.qhimg.com/t010aba4345b02168d6.gif")
    
    p.desc-text
        | 说明
        br
        | 1 最多对10个页面进行监测。
        br
        | 2 新增热力图时，请确保监测页面已添加360分析代码且已生效。
    
    v-modal(
        :visible="modalVisible",
        :title="modalStatus === 'new' ? '新增热力图' : '编辑热力图配置'",
        @closemodal="modalVisible = false"
    )
        .modal-content(style="width: 600px")
            div.form
                dl.item
                    dt.label 页面名称
                    dd.control
                        input.size-big(class="size-normal", v-model="siteModel.pagename", ref="pnameInput", placeholder="请输入1-50字符名称")
                        em.error(v-show="heatSiteError.pagename.oversize") 最多填写50个字符
                dl.item
                    dt.label 页面URL
                    dd.control
                        input.size-big(class="size-normal", v-model="siteModel.url", ref="urlInput", placeholder="请输入URL 如：http://aaa.com，可通配")
                        em.error(v-show="!heatSiteError.url.invalid && heatSiteError.url.oversize") 长度不得大于 1000
                        em.error(v-show="heatSiteError.url.invalid") 请输入正确格式的 URL
                dl.item
                    dt.label 设置网页在浏览器中显示位置
                    dd.control
                        v-radio-group(
                            :options="[{title: '居左', value: 0}, {title: '居中', value: 1}, {title: '居右', value: 2}]",
                            v-model="siteModel.location"
                        )
                
                div.mutil-expr
                    p.ellipsis 若您的页面对应多个链接或者您想要统计一组页面，请
                        cite(@click="toggleModalExt") 设置统计范围
                            span.arrow(v-show="!siteModel.showExt") ▸
                            span.arrow(v-show="siteModel.showExt") ▾
                    div(v-show="siteModel.showExt")
                        p.ellipsis 当前展示页面：
                            cite(:title="siteModel.url") {{siteModel.url}}
                        p
                            dt.label 统计页面：
                            dd.control
                                input.size-big(class="size-normal", v-model="siteModel.ext_url", placeholder="请输入URL 如：http://aaa.com，可通配")
                                em.error(v-show="heatSiteError.ext_url.invalid") 请输入正确格式的 URL
                                em.error(v-show="!heatSiteError.ext_url.invalid && heatSiteError.ext_url.oversize") 长度不得大于 1000
                                em.error(v-show="!heatSiteError.ext_url.empty && !heatSiteError.ext_url.invalid && !heatSiteError.ext_url.oversize && asteriskAbsent") 未包含通配符
                        p.tip
                            span 统计一组页面的数据需要在URL中使用 * 进行通配
                            v-tooltip(tip="若您想监测某注册完成页http://www.aaa.com/sign_up/id=xxx，不同访客有不同id，则目标页面可设置为http://www.aaa.com/sign_up/id=*；若您想监测某页面不同渠道的流量来源数据，可将该目标页面设置为http://www.aaa.com/*。", pos="right")
                                i.fa.fa.fa-question-circle

                div.modal-tip
                    | 注意：请在所有想统计的页面上安装360分析代码
        .btn-wrap
            input.btn.btn-primary.btn-small(type="button", value="提交", @click="submitModal(siteModel)", :class="{disabled: !canSubmit}")
            input.btn.btn-default.btn-small(type="button", value="取消", @click="modalVisible = false")
</template>

<script>
import Vue from 'vue'
import { getDateString } from '../../script/util'
import qs from 'query-string'

const toPercent = Vue.filter('percent')
const RE_HTTP = /^https?:\/\/[a-zA-Z0-9][a-zA-Z0-9-]*\.[a-zA-Z0-9]+[^\s]*\s*$/
const defaultSiteModel = {
    showExt: false,
    pagename: '',
    url: '',
    location: 1,
    ext_url: ''
}

export default {
    data() {
        let today = getDateString.today()
        return {
            tableList: [],
            totalListNum: 0,
            isListLoading: true,
            modalVisible: false,
            siteModel: _.cloneDeep(defaultSiteModel),
            modalStatus: 'new'
        }
    },

    computed: {
        domainId() {
            return this.$store.state.domainId
        },
        heatSiteError() {
            let { pagename, url, ext_url, showExt } = this.siteModel
            pagename = _.trim(pagename)
            url = _.trim(url)
            ext_url = _.trim(ext_url)

            return {
                pagename: {
                    oversize: pagename.length > 50,
                    invalid: false,
                    empty: !pagename
                },
                url: {
                    oversize: url.length > 1000,
                    invalid: url.length && !RE_HTTP.test(url),
                    empty: !url
                },
                ext_url: {
                    oversize: showExt && ext_url.length > 1000,
                    invalid: showExt && ext_url.length && !/^\s*https?:\/\/[a-zA-Z0-9-*]+\.[a-zA-Z0-9*]+[^\s]*\s*$/.test(ext_url),
                    empty: showExt && !ext_url
                }
            }
        },
        asteriskAbsent() {
            let ext_url = this.siteModel.ext_url || ''
            return ext_url.indexOf('*') === -1
        },
        canSubmit() {
            let errObj = this.heatSiteError
            return Object.keys(errObj).every((key) => {
                let o = errObj[key]
                return Object.keys(o).every(k => o[k] === false)
            })
        }
    },

    watch: {
        domainId() {
            this.getHeatList()
        }
    },

    methods: {
        openHeatmap(item) {
            let host = location.hostname
            let url = `http://${host}/web/heatmap?` + qs.stringify({
                domainId: this.domainId,
                heatmapId: item.id,
                url: item.url,
                pagename: item.pagename
            })
            window.open(url)
        },
        getHeatList() {
            if (!this.domainId) {
                return
            }

            this.isListLoading = true
            this.tableList = []

            this.$http.get('/api/heatmap/list', {
                params: { domainId: this.domainId }
            }).then(r => {
                return r.data || {}
            }).catch(e => {
                return {}
            }).then(data => {
                let { list = [], total = 0 } = data
                list.forEach(res => res.bstatus = String(res.bstatus))
                this.isListLoading = false
                this.totalListNum = total
                this.tableList = list
            })
        },

        deleteItem(item) {
            this.$Modal.confirm('确定删除？', (confirm) => {
                if (!confirm) return

                this.$http.get('/api/heatmap/del', {
                    params: {
                        domainId: this.domainId,
                        id: item.id
                    }
                }).then(res => {
                    let data = res.data
                    if (data.errno === 0) {
                        this.tableList.splice(_.indexOf(this.tableList, item), 1)
                        this.totalListNum--
                    } else {
                        this.$Modal.warn(data.errmsg)
                    }
                }).catch(e => {
                    this.$Modal.warn('删除失败')
                })
            })
        },

        createItem() {
            if (this.canSubmit) {
                let model = this.siteModel
                const domainId =  this.domainId

                let params = _.keys(model).reduce((accu, key) => {
                    accu[key] = _.trim(`${model[key]}`)
                    return accu
                }, { domainId })

                params.url = encodeURIComponent(params.url)
                params.ext_url = encodeURIComponent(params.ext_url)

                this.$http.get('/api/heatmap/add', {  params }).then(res => {
                    return res.data
                }).catch(e => {
                    return null
                }).then(data => {
                    if (data && data.errno === 0) {
                        let result = data.data
                        result.bstatus = String(result.bstatus)
                        let newData = _.extend(result, {
                            createtime: result.updatetime,
                            domainId
                        })
                        
                        this.modalVisible = false
                        this.tableList.push(newData)
                        this.totalListNum++
                    } else {
                        this.$Modal.warn(data && data.errmsg || '添加失败！')
                    }
                })
            }
        },

        updateItem(item) {
            let params = _.extend({}, item, { domainId: this.domainId })
            return this.$http.get('/api/heatmap/edit', { params }).then(res => {
                let data = res.data
                if (!data || data.errno > 0) {
                    throw data.errmsg
                }
            })
        },

        changeItemBstate(item, value) {
            item.bstatus = value
            this.updateItem(item).catch((e) => {
                item.bstatus = String(+value ? 0 : 1)
                this.$Modal.warn(typeof e === 'string' ? e : '状态修改失败')
            })
        },

        submitModal(item) {
            if (!this.canSubmit) {
                return
            }

            if (this.modalStatus === 'new') {
                return this.createItem(item)
            }

            this.updateItem(item).then(() => {
                let index = _.findIndex(this.tableList, { id: item.id })
                if (index > -1) {
                    this.tableList.splice(index, 1, item)
                    this.modalVisible = false
                }
            }).catch((e) => {
                this.$Modal.warn(typeof e === 'string' ? e : '状态修改失败')
            })
        },

        addNewURL() {
            const maxCount = +this.domainId === 104553 ? 20 : 10
            if (this.totalListNum >= maxCount) {
                this.$Modal.warn('超过限额，不能添加！')
            } else {
                this.modalStatus = 'new'
                this.siteModel = _.cloneDeep(defaultSiteModel)
                this.modalVisible = true
                this.$nextTick(() => {
                    this.$refs.pnameInput.focus()
                })
            }
        },

        openEdit(item) {
            this.modalStatus = 'edit'
            let model = _.cloneDeep(item)
            this.siteModel = _.extend(model, {showExt: item.ext_url.length > 0})
            this.modalVisible = true
            this.$nextTick(() => {
                this.$refs.pnameInput.focus()
            })
        },

        toggleModalExt() {
            this.siteModel.showExt = !this.siteModel.showExt
        }
    },
    created() {
        this.getHeatList()
    }
}

</script>

<style scoped>
@import '../../css/base/variables.css';

.zone {
    background: #fff;
    overflow: hidden;
    margin-bottom: 0;
}

.data-table .ta-l {
    text-align: left;
}
/*
.data-table tbody tr {
    background: #fff;
}
.data-table tbody tr:hover {
    background: #EAF3FD;
}
*/
.operate-cell .fa {
    margin-right: 5px;
}
.add-site {
    font-size: 12px;
}
.desc-text {
    margin-top: 20px;
    color: #596980;
    font-size: 12px;
}

.form .label {
    min-width: 50px;
}
.mutil-expr {
    background: #ebf5ff;
    padding: 10px 10px;
    margin-bottom: 0.84em;
    line-height: 2;

    & cite {
        cursor: pointer;
        color: #56bf8b;
    }

    & p {
        margin: 0;
    }
}
.mutil-expr .tip {
    color: #333;
    margin: 0;
    font-weight: bold;

    & > span {
        vertical-align: middle;
    }

    & > .tooltip {
        color: #000;
        margin-left: 5px;
    }
}
.modal-tip {
    margin-top: 10px;
    font-size: 12px;
    color: #9ca0a2;
}

.ellipsis {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
.arrow {
    display: inline-block;
    margin-left: 2px;
    font-size: 14px;
}
</style>



// WEBPACK FOOTER //
// heatlist.vue?f2d8d98a